module.exports = __webpack_public_path__ + "static/media/mentor.43dd5a64.png";